<template>
  <div class="home-page idcard-page">
    <Header ref="childRef"></Header>
    <div class="idcard-back" @click="back">
      <img src="../../static/images/back.png"/>
    </div>
    <main class="idcard-form crfff">
      <section class="idcard-intro">
        <h1>{{ $t('IpIMage') }}</h1>
        <p>{{ $t('IpIMage_content') }}</p>
      </section>

      <section class="idcard-settings">
        <div class="idcard-option-group">
          <div class="idcard-option-title">{{ $t('Choose_background') }}</div>
          <div class="idcard-choice-row idcard-background-row">
            <button type="button" class="idcard-choice idcard-background-choice" :class="{'active':id_background==item.key}"
                    v-for="item in petList" :key="item.key" @click="getClick(item)">
              <i class="idcard-color-dot" :style="{backgroundColor: item.key}"></i>
              <span>{{ $t(item.title) }}</span>
              <b v-if="id_background==item.key">✓</b>
            </button>
          </div>
        </div>

        <div class="idcard-option-group idcard-size-group">
          <div class="idcard-option-title">{{ $t('Choose_size') }}</div>
          <div class="idcard-choice-row idcard-size-row">
            <button type="button" class="idcard-choice idcard-size-choice" :class="{'active':id_size==item.key}"
                    v-for="item in sizeList" :key="item.key" @click="getClick_size(item)">
              <span>{{ $t(item.title) }}</span>
              <b v-if="id_size==item.key">✓</b>
            </button>
          </div>
        </div>

        <div id="controlBox" class="oneImageInput idcard-upload" @click="handleUploadClick">
          <input type="file" @click.stop="handleFileInputClick" @change="convertToBase64_v2" class="file" accept=".jpg, .jpeg, .png, .webp" ref="imageInput">
          <div class="imageInputBox">
            <div class="uploadBox uploadIcon">
              <img class="idcard-preview" v-if="imageBase64" :src="imageBase64"/>
              <div class="idcard-upload-empty" v-else>
                <img src="../../static/images/transparent.png">
                <div class="label">{{ $t('Upload') }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="idcard-generate">
        <button @click="uploadImage" class="button">
        <strong>{{ $t('Generate') }}</strong></button>
      </div>
    </main>
    <div class="idcard-credit-row">
      <button class="btn btn-blue">{{ $t('ChancesLeft') }}: {{ score }}</button>
      <button class="btn" @click="goPurchaseChances">
        <strong>{{ $t('BuyChances') }}</strong>
        <img src="../../static/images/buy.png"></button>
    </div>
    <Dialog class="result-image-dialog" ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="alert-modal" slot="mdBox">
        <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
          <div class="image ac" v-if="imageShow">
            <div class="" style="font-size:1rem;margin-bottom: 1rem;">{{ shouldCopyMediaLink() ? $t('downTips1') : $t('downloadImageTips') }}</div>
          <img v-if="isShowResult==1" :src="detail.url" style="width:80%;"/>
          <img v-if="isShowResult==2" :src="detail.url_2" style="width:80%;"/>
          <img v-if="isShowResult==3" :src="detail.original_url" style="width:80%;"/>
          <div class="tab tab2 mt20">
            <span @click="getResult(1)" :class="{'active':isShowResult==1}">{{ $t('Result') }}</span>
            <span @click="getResult(2)" :class="{'active':isShowResult==2}">{{ $t('Result') }}</span>
            <span @click="getResult(3)" :class="{'active':isShowResult==3}">{{ $t('Original') }}</span>
          </div>
          <div class="img-tools" v-if="shouldCopyMediaLink()">
            <div class="ac disflex mt30">
              <div class="input-item">
                <div class="input-item2" v-if="isShowResult==1">
                  <input class="input" disabled :value="getDownloadUrl()" type="" placeholder="">
                  <img id="copycode" :data-clipboard-text="getDownloadUrl()" @click="copy" v-if="detail.url"
                       style="margin-left: 10px;" width="90" src="../../static/images/Copy.png"/>
                </div>
                <div class="input-item2" v-if="isShowResult==2">
                  <input class="input" disabled :value="getDownloadUrl()" type="" placeholder="">
                  <img id="copycode" :data-clipboard-text="getDownloadUrl()" @click="copy" v-if="detail.url_2"
                       style="margin-left: 10px;" width="90" src="../../static/images/Copy.png"/>
                </div>
                <div class="input-item2" v-if="isShowResult==3">
                  <input class="input" disabled :value="getDownloadUrl()" type="" placeholder="">
                  <img id="copycode" :data-clipboard-text="getDownloadUrl()" @click="copy" v-if="detail.original_url"
                       style="margin-left: 10px;" width="90" src="../../static/images/Copy.png"/>
                </div>
              </div>
            </div>
          </div>
          <div class="ac mt30" v-else>
            <button class="button fw7" style="width: 100%;font-size: 1rem" @click="downloadImage">{{ $t('downloadImage') }}</button>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog ref="BrowserDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 50rem">
      <div class="alert-modal" slot="mdBox">
        <div class="close" @click="closeBrowserDialog" style="text-align: right;margin: 0 auto;font-size: 2rem;">×</div>
        <div class="image ac">
          <div class="" style="font-size:1rem;margin-bottom: 1rem;">{{ $t('copy_project_url') }}</div>
          <div class="img-tools">
            <div class="ac mt20">
              <div class="input-item mt50" style="margin-bottom: 1.5rem;width: 80%">
                <div class="input-item2">
                  <input class="input" v-model="project_url" disabled placeholder="">
                </div>
              </div>
              <button class="button fw7" style="width: 100%;font-size: 1rem" id="copycode"
                      :data-clipboard-text="project_url" @click="copy" v-if="project_url">{{ $t('copyLink') }}
                <img style="width: 1.2rem" src="../../static/images/copy1.png"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
import { saveMedia, shouldCopyMediaLink } from '../utils/mediaDownload'
import { readCompressedPhoto } from '../utils/photoUpload'

export default {
  components: {
    Header, Dialog
  },
  data() {

    return {
      detail: {},
      isShow: false,
      value: 50,
      imageShow: false,
      imageBase64: null,
      imageTpye: '',
      withScratch: false,
      isImgModel: false,
      isImage: true,
      score: 0,
      id_background: '',
      id_size: '',
      petList: [
        {'title': 'white', 'key': "#FFFFFF"},
        {'title': 'blue', 'key': "#3294e6"},
        // {'title':'light gray','key':"#D3D3D3"},
      ],
      sizeList: [
        {'title': '1 inch', 'key': 'size_1'},
        {'title': '2 inches', 'key': 'size_2'},
        {'title': '3 inches', 'key': 'size_3'},
      ],
      isShowHeader: true,
      isShowResult: 1,
      project_url: ""
    }
  },
  watch: {},
  computed: {},
  mounted() {
    let that = this;
  },
  created() {
    this.project_url = this.getProjectUrl()
    this.getHome();
  },
  methods: {
    shouldCopyMediaLink,
    getProjectUrl() {
      const token = localStorage.getItem('token') || ''
      return token ? 'https://camem-app.snapai.asia?token=' + encodeURIComponent(token) : 'https://camem-app.snapai.asia'
    },
    getResult(type) {
      this.isShowResult = type
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    getClick(item) {
      this.id_background = item.key
    },
    getClick_size(item) {
      this.id_size = item.key
    },
    back() {
      this.$router.go(-1);
    },
    getHome() {
      let that = this;
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.score = r.data.score
        });
      })
    },
    getCharactersAfter(str, charToFind) {
      var index = str.indexOf(charToFind);
      if (index !== -1) {
        return str.slice(index + 1);
      }
      return ''; // 如果字符未找到，返回空字符串
    },
    convertToBase64(event) {
      const file = event.target.files[0];
      this.imageTpye = this.getCharactersAfter(file.type, '/');
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBase64 = e.target.result;
          // 在这里可以将Base64字符串上传到服务器
          // this.uploadImage(this.imageBase64);
        };
        reader.readAsDataURL(file);
      }
    },
    convertToBase64_v2(event) {
      const file = event.target.files[0];
      if (!file) return;
      event.target.value = '';
      this.imageBase64 = null;
      this.imageTpye = '';
      readCompressedPhoto(file).then(({ content, type }) => {
        this.imageBase64 = content;
        this.imageTpye = type;
      }).catch(error => {
        this.$utils.alertText(this.$t(error.message === 'photoTooLarge' ? 'photoTooLarge' : 'photoReadFailed'), 100, 4000);
      });
    },
    // 辅助方法：计算 base64 图片大小
    base64Size(base64) {
      let str = base64.split(',')[1]; // 去掉前缀 data:image/jpeg;base64,
      let eqIndex = str.indexOf('=');
      if (eqIndex > 0) {
        str = str.substring(0, eqIndex); // 去掉填充字符
      }
      let length = str.length;
      return length * 3 / 4; // 得到字节数
    },
    uploadImage() {
      let that = this
      if (!that.id_background) {
        that.$utils.alertText(that.$t('petTitle2'), 100);
        return;
      } else if (!that.id_size) {
        that.$utils.alertText(that.$t('petTitle2'), 100);
        return;
      } else if (!that.imageBase64) {
        that.$utils.alertText(that.$t('uploadTips'), 100);
        return;
      }
      let data = {
        image: {
          type: that.imageTpye,
          content: that.imageBase64
        },
        back_color: that.id_background,
        pic_size: that.id_size,
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/idcard', data, r => {
        if (r.code == 0) {
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg, 100);
          return;
        }
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.$nextTick(() => {
            that.$refs.childRef.getInfo()
          });
          that.getHome()
          that.$refs.imgDialog.showMaskFun();
          that.imageShow = true
          that.detail = r.data
        });
      })
    },
    getImage() {
      this.downloadImage()
    },
    getDownloadUrl() {
      if (this.isShowResult == 1) {
        return this.detail.download_url || this.detail.url
      }
      if (this.isShowResult == 2) {
        return this.detail.download_url_2 || this.detail.url_2
      }
      return this.detail.download_original_url || this.detail.original_url
    },
    downloadImage() {
      let imageUrl = this.getDownloadUrl()
      saveMedia(imageUrl)
    },
    closeTmgDialog() {
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    goPurchaseChances() {
      this.$router.push({path: '/purchaseChances'})
    },
    // 新增点击上传入口
    handleUploadClick() {
      if (this.isAndroidWebView()) {
        this.openBrowserDialog();
        return;
      }
      this.$refs.imageInput.click();
    },
    handleFileInputClick(event) {
      if (!this.isAndroidWebView()) return;
      event.preventDefault();
      this.openBrowserDialog();
    },
    isAndroidWebView() {
      const ua = navigator.userAgent || '';
      // 1. 先确认是Android设备
      if (!/Android/i.test(ua)) return false;

      const isWeChat = /MicroMessenger/i.test(ua);
      const isVivoBrowser = /VivoBrowser/i.test(ua);
      const isMiuiBrowser = /MiuiBrowser/i.test(ua);
      const isHuaweiBrowser = /HuaweiBrowser/i.test(ua);

      // 2. 检测明确的WebView特征
      const hasWebViewMarkers = (
        /\bwv\b/.test(ua) ||          // 标准WebView标记
        /; wv\)/.test(ua) ||          // 另一种WebView格式
        /WebView/.test(ua) ||         // 部分OEM厂商的WebView
        /XWEB_/.test(ua)              // 微信XWEB内核
      );
      // 3. 排除已知浏览器（更严格的白名单）
      const isNormalBrowser = (
        /Chrome\/[.0-9]+ Mobile Safari\/[.0-9]+/.test(ua) &&
        !/; wv\)/.test(ua)            // 确保不是WebView伪装的Chrome
      );

      // ✅ 排除特定厂商浏览器（如 Vivo 浏览器）
      const isTrustedBrowser = isVivoBrowser || isMiuiBrowser || isHuaweiBrowser;

      return !isNormalBrowser && !isTrustedBrowser && (hasWebViewMarkers || !/Chrome\//.test(ua));
      // return hasWebViewMarkers || !isNormalBrowser;
    },
    // 跳转系统浏览器
    openInBrowser() {
      this.$utils.alertText(this.$t('redirect_tip'), 100);
      const mobile = localStorage.getItem('mobile') || '';
      const currentUrl = new URL(window.location.href);
      const baseUrl = currentUrl.origin + currentUrl.pathname;
      const hash = currentUrl.hash; // #/sexPicture?type=1
      const hashUrl = new URL(hash.slice(1), 'http://temp');
      hashUrl.searchParams.set('mobile', mobile);
      const finalUrl = `${baseUrl}#${hashUrl.pathname}?${hashUrl.searchParams.toString()}`;
      const schemeLessUrl = finalUrl.replace(/^https?:\/\//, '');
      const fallbackUrl = encodeURIComponent(finalUrl);
      const intentUrl = `intent://${schemeLessUrl}#Intent;scheme=https;S.browser_fallback_url=${fallbackUrl};end`;
      window.location.href = intentUrl;
    },
    openBrowserDialog() {
      this.$refs.BrowserDialog.showMaskFun();
    },
    closeBrowserDialog() {
      this.$refs.BrowserDialog.closeMask();
    }
  }
}
</script>
<style>
input.iosSwitch {
  position: relative;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
  width: 80px;
  height: 40px;
  background-color: #fff;
  border: 1px solid #d9dadc;
  border-radius: 50px;
  box-shadow: inset -20px 0 0 0 #fff;
  margin-right: 15px;
}

input.iosSwitch:after {
  content: "";
  position: absolute;
  top: 1px;
  left: 1px;
  background: 0 0;
  width: 46px;
  height: 36px;
  border-radius: 50%;
  box-shadow: 2px 4px 6px rgba(0, 0, 0, .2);
}

input.iosSwitch:checked {
  border-color: #0062ff
}

input.iosSwitch:checked:after {
  left: 20px;
  box-shadow: -2px 4px 3px rgba(0, 0, 0, .05);
}

.imageInputBox {
  padding: 3rem 3rem;
  min-height: 4rem;
}

#activeFormBox input.file, #controlBox input.file {
  width: 100%;
  height: 100%;
  opacity: 0;
  overflow: hidden;
  z-index: 10;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}

.oneImageInput {
  background: #020e5bb8;
  border-radius: 1rem;
  box-shadow: 0 0 0.5rem #49c1ff;
  border: 0.1rem solid #fff;
  position: relative
}

.oneImageInput-content {
  position: relative;
}

.withScratchBox {
  padding: 40px;
  border-top: 2px solid #fff;
}

.uploadIcon .label {
  color: #ffffff;
  margin-top: 1rem;
}

.idcard-page {
  min-height: 100%;
  padding-bottom: 1.2rem;
}

.idcard-back {
  width: 90%;
  max-width: 27rem;
  margin: 0.35rem auto 0.75rem;
  text-align: left;
}

.idcard-back img {
  width: 1.35rem;
  padding: 0.2rem;
  cursor: pointer;
}

.idcard-form {
  width: 90%;
  max-width: 27rem;
  margin: 0 auto;
}

.idcard-intro {
  text-align: center;
  padding: 0.65rem 0.8rem;
  margin-bottom: 0.7rem;
  border: 0.01rem solid rgba(255, 255, 255, 0.35);
  border-radius: 0.5rem;
  background: rgba(3, 12, 54, 0.45);
  box-shadow: 0 0 0.7rem rgba(246, 39, 160, 0.25);
}

.idcard-intro h1 {
  margin: 0 0 0.3rem;
  font-size: 1.45rem;
  line-height: 1.2;
}

.idcard-intro p {
  margin: 0;
  font-size: 0.73rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.9);
}

.idcard-settings {
  padding: 0.75rem;
  border: 0.01rem solid rgba(108, 207, 255, 0.55);
  border-radius: 0.65rem;
  background: rgba(4, 11, 53, 0.8);
  box-shadow: 0 0 0.6rem rgba(73, 193, 255, 0.25);
}

.idcard-option-group + .idcard-option-group {
  margin-top: 0.8rem;
}

.idcard-option-title {
  margin-bottom: 0.45rem;
  font-size: 0.88rem;
  font-weight: 700;
  text-align: left;
}

.idcard-choice-row {
  display: flex;
  gap: 0.4rem;
}

.idcard-choice {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  min-height: 2.1rem;
  padding: 0.3rem 0.25rem;
  border: 0.01rem solid rgba(255, 255, 255, 0.35);
  border-radius: 0.35rem;
  background: rgba(35, 44, 107, 0.85);
  color: #fff;
  font-family: inherit;
  font-size: 0.76rem;
}

.idcard-choice.active {
  border-color: #fff;
  background: linear-gradient(90deg, #1977ff, #6947db, #db3c9d);
  box-shadow: 0 0 0.35rem rgba(246, 39, 160, 0.6);
}

.idcard-background-choice {
  width: calc(50% - 0.2rem);
}

.idcard-size-choice {
  width: calc((100% - 0.8rem) / 3);
}

.idcard-color-dot {
  width: 0.7rem;
  height: 0.7rem;
  border: 0.01rem solid rgba(255, 255, 255, 0.85);
  border-radius: 50%;
  box-shadow: 0 0 0.15rem rgba(255, 255, 255, 0.35);
}

.idcard-choice b {
  position: absolute;
  right: 0.2rem;
  top: 0.05rem;
  font-size: 0.6rem;
}

.idcard-upload {
  height: 8.8rem;
  margin-top: 0.85rem;
  overflow: hidden;
}

.idcard-upload .imageInputBox {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 0;
  padding: 0.55rem;
}

.idcard-upload .uploadBox {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.idcard-preview {
  max-width: 90%;
  max-height: 100%;
  border-radius: 0.35rem;
  object-fit: contain;
}

.idcard-upload-empty img {
  width: 2.6rem;
}

.idcard-upload-empty .label {
  margin-top: 0.4rem;
  font-size: 0.85rem;
}

.idcard-generate {
  margin-top: 0.75rem;
  text-align: center;
}

.idcard-generate .button {
  width: 72%;
  max-width: 13rem;
}

.idcard-credit-row {
  display: flex;
  justify-content: center;
  gap: 0.45rem;
  width: 90%;
  max-width: 27rem;
  margin: 0.75rem auto 0;
}

.idcard-credit-row .btn {
  flex: 1;
  min-width: 0;
  margin-left: 0 !important;
  padding: 0.25rem 0.35rem;
  font-size: 0.72rem;
  white-space: nowrap;
}

.idcard-credit-row .btn img {
  width: 0.85rem;
  margin-left: 0.25rem;
}


</style>



// WEBPACK FOOTER //
// src/page/idcard.vue